module.exports = __webpack_public_path__ + "static/media/EditFy.4147e9b9.svg";